import { tagAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(tagAnatomy.keys);

const baseStyle = definePartsStyle(({ colorScheme }) => ({
  container: {
    backgroundColor: `${colorScheme}.500`,
    borderRadius: "full",
    color: "white",
    justifyContent: "center",
    width: "full",
  },
  label: {
    textAlign: "center",
    width: "full",
  },
}));

const tagTheme = defineMultiStyleConfig({
  baseStyle,
  defaultProps: {
    colorScheme: "gray",
  },
});

export default tagTheme;
